export default "__VITE_ASSET__9001e27e__"